import { useState, useEffect } from 'react';
import useApi from './useApi';

export interface PrecioAnillado {
  id: number;
  precio: number;
  min_hojas: number;
  max_hojas: number;
  hoja_name: string;
  hoja_width: number;
  hoja_height: number;
}

export const usePreciosAnillado = () => {
  const [precios, setPrecios] = useState<PrecioAnillado[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { getPreciosAnillado } = useApi();

  const fetchPrecios = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await getPreciosAnillado();
      
      if (response && response.success) {
        setPrecios(response.data);
      } else {
        setError('Error al obtener los precios de anillado');
      }
    } catch (err) {
      setError('Error de conexión');
      console.error('Error fetching precios de anillado:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrecios();
  }, []);

  const refreshPrecios = () => {
    fetchPrecios();
  };

  return {
    precios,
    loading,
    error,
    refreshPrecios
  };
};
